import React from 'react';
import { _transformAlgoliaToProductDetails } from '~/features/productList/Algoliga.utils';
import { useProductHandler } from '~/services/search/useProductHandler';
import { TProductDetails } from '~/shared/components/ProductCard/ProductCard.definition';
import { SimpleProductList } from '~/shared/components/SimpleProductList';
import { useAlgoliaQuery } from '~/shared/hooks/useAlgoliaQuery';
import { useUtils } from '~/shared/hooks/useUtils';
import { useTranslation } from '~/shared/utils/translation';
import { useProduct } from '../hooks/usePDPStore';
import { SFProduct } from '../pdp.definitions';
import { GTM_LIST_ID, GTM_LIST_NAME } from '~/shared/hooks/useEvents/useGTMEvents/models';

export const MatchingProducts = () => {
    const getProductHandler = useProductHandler();
    const { convertPriceToLocale } = useUtils();
    const { translate } = useTranslation();
    const { product } = useProduct();
    const matchingProductIds = product?.recommendations?.map(
        (recommendation) => recommendation.recommendedItemId,
    );
    const { data } = useAlgoliaQuery<{ hits: SFProduct[] }, TProductDetails[]>(
        { filters: 'id:' + matchingProductIds?.join(' OR id:') },
        {
            queryKey: [JSON.stringify({ filters: 'id:' + matchingProductIds?.join(' OR id:') })],
            select: (data) => {
                return data.hits.map((hit) =>
                    _transformAlgoliaToProductDetails(hit, translate, convertPriceToLocale),
                ) as TProductDetails[];
            },
            enabled: !!matchingProductIds,
        },
    );

    if (!data?.length) return null;

    return (
        <div style={{ width: '100%' }}>
            <SimpleProductList
                listId={GTM_LIST_ID.COMPLEMENTARY_PRODUCTS}
                listName={GTM_LIST_NAME.COMPLEMENTARY}
                variant="large"
                items={data}
                header={translate('pdp.itemsInThisCategory')}
                productHandler={getProductHandler}
            />
        </div>
    );
};
